/*
 * @Author: 黄贺林
 * @Date: 2024-06-19 09:31:20
 * @LastEditTime: 2024-08-09 14:31:20
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import modules from './modules';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules,
    plugins: [
        createPersistedState({
            storage: window.localStorage,
            // key: "store",
        })
    ]
})